// dependencies
import React from "react";

import Text from "../../../../../../components/Text";
// components
import { CardBody, CardHeader } from "../../../../components/Card";
import ParticipationChart from "./ParticipationChart";

// styles
import css from "./Participation.module.scss";

const Participation = () => {
	return (
		<>
			<CardHeader
				title={
					<Text element="span" size="paragraph-2" weight="semi-bold">
						Participation Rate by Month
					</Text>
				}
				info="Percentage of participation by month."
			/>
			<CardBody>
				<div className={css.cardBody}>
					<ParticipationChart />
				</div>
			</CardBody>
		</>
	);
};

export default Participation;
